module.exports = __webpack_public_path__ + "img/help.5286d5d5.svg";